<button
    (click)="openCloseGroups($event)"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    class="tertiary-btn group-by-btn"
    [ngClass]="{ opened: isOverlayGroupsOpen() }"
>
    <span class="icon groupBy" [innerHTML]="groupByIcon"></span>
    Group by
</button>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOverlayGroupsOpen()"
    (overlayOutsideClick)="onOverlayOutsideClick()"
    (detach)="closeGroupsOverlay()"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-custom-backdrop'"
    (backdropClick)="closeGroupsOverlay()"
>
    <div class="content" [ngClass]="{ show: isOverlayGroupsOpen() }">
        @if (!groupOpened()) {
            <div class="content-body">
                @for (item of groupingLevels; track item) {
                    <button
                        class="resetStyles group-btn"
                        (click)="openLevel(item, $event)"
                        [disabled]="!groupIsEnable(item)"
                    >
                        <span class="group-level">{{ item.name }}</span>
                        @if (appliedGroups()[item.level - 1]) {
                            <small class="group-title">{{ appliedGroups()[item.level - 1].headerName }}</small>
                        }
                        <span class="icon nextArrow" [innerHTML]="arrowIcon"></span>
                    </button>
                }
            </div>
            <div class="buttons-section">
                <button class="resetStyles clear-btn" [disabled]="!appliedGroups().length" (click)="clearSelection()">
                    Clear All
                </button>
            </div>
        }

        @if (groupOpened(); as openedGroup) {
            <app-column-selector
                cdkTrapFocus
                cdkTrapFocusAutoCapture="true"
                [cols]="getAvailableCols(openedGroup)"
                [group]="openedGroup"
                [appliedGroups]="appliedGroups()"
                (selectedColumnChange)="applyGroup(openedGroup, $event)"
                (closeOverlayEvent)="closeOverlay()"
            ></app-column-selector>
        }
    </div>
</ng-template>
